// extracted by mini-css-extract-plugin
export var center = "_5i-2";
export var clickableRow = "_5i-5";
export var expandedRow = "_5i-7";
export var hoverable = "_5i-4";
export var left = "_5i-1";
export var right = "_5i-3";
export var row = "_5i-0";
export var selectedRow = "_5i-6";
export var summaryRow = "_5i-8";